"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.StyledSubmitBlock = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _Button = _interopRequireDefault(require("../../../Button"));
var _Checkbox = _interopRequireDefault(require("../../../Checkbox"));
var _userflow = _interopRequireDefault(require("../../../../styles/userflow"));
var SubmitBlock = function SubmitBlock(props) {
  var children = props.children,
    _props$className = props.className,
    className = _props$className === void 0 ? '' : _props$className,
    _props$buttonTitle = props.buttonTitle,
    buttonTitle = _props$buttonTitle === void 0 ? '' : _props$buttonTitle,
    _props$confirmationTi = props.confirmationTitle,
    confirmationTitle = _props$confirmationTi === void 0 ? '' : _props$confirmationTi,
    _props$onSubmit = props.onSubmit,
    onSubmit = _props$onSubmit === void 0 ? Function.prototype : _props$onSubmit,
    _props$isMobile = props.isMobile,
    isMobile = _props$isMobile === void 0 ? false : _props$isMobile;
  var _React$useState = _react["default"].useState(false),
    _React$useState2 = (0, _slicedToArray2["default"])(_React$useState, 2),
    submitConfirmed = _React$useState2[0],
    setSubmitConfirmed = _React$useState2[1];
  var handleSubmitConfirmation = function handleSubmitConfirmation(_ref) {
    var target = _ref.target;
    var checked = target.checked;
    setSubmitConfirmed(checked);
  };
  var btn = /*#__PURE__*/_react["default"].createElement(StyledSubmitButton, {
    disabled: !submitConfirmed,
    onClick: onSubmit,
    isMobile: isMobile
  }, buttonTitle);
  var checkbox = /*#__PURE__*/_react["default"].createElement(StyledSubmitConfirmationCheckbox, {
    checked: submitConfirmed,
    onChange: handleSubmitConfirmation,
    isMobile: isMobile
  }, confirmationTitle);
  return /*#__PURE__*/_react["default"].createElement(StyledSubmitBlock, {
    className: className
  }, children, /*#__PURE__*/_react["default"].createElement(StyledSubmitButtonsContainer, {
    isMobile: isMobile
  }, isMobile ? /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, checkbox, btn) : /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, btn, checkbox)));
};
var StyledSubmitBlock = exports.StyledSubmitBlock = _styledComponents["default"].div.withConfig({
  displayName: "SubmitBlock__StyledSubmitBlock",
  componentId: "sc-1d8zxf1-0"
})(["padding:16px;background-color:", ";border-radius:0 0 4px 4px;"], _userflow["default"].colors.pinkBase);
var StyledSubmitButtonsContainer = _styledComponents["default"].div.withConfig({
  displayName: "SubmitBlock__StyledSubmitButtonsContainer",
  componentId: "sc-1d8zxf1-1"
})(["margin-top:8px;display:flex;", ""], function (_ref2) {
  var isMobile = _ref2.isMobile;
  return "".concat(isMobile ? "flex-direction: column;" : "flex-direction: row;");
});
var StyledSubmitButton = (0, _styledComponents["default"])(_Button["default"]).withConfig({
  displayName: "SubmitBlock__StyledSubmitButton",
  componentId: "sc-1d8zxf1-2"
})(["height:40px;min-width:150px;width:auto;background:", ";border-radius:2px;border:none;font-weight:normal;font-size:14px;line-height:16px;color:", ";&:disabled{font-style:normal;font-weight:normal;font-size:14px;line-height:16px;pointer-events:none;opacity:0.4;}&:hover{opacity:0.6;color:", ";}", ""], _userflow["default"].colors.monza, _userflow["default"].colors.white, _userflow["default"].colors.white, function (_ref3) {
  var isMobile = _ref3.isMobile;
  return isMobile && "margin-top: 8px;";
});
var StyledSubmitConfirmationCheckbox = (0, _styledComponents["default"])(_Checkbox["default"]).withConfig({
  displayName: "SubmitBlock__StyledSubmitConfirmationCheckbox",
  componentId: "sc-1d8zxf1-3"
})(["display:inline-flex;align-items:center;font-size:14px;color:", ";", " ", ""], _userflow["default"].colors.blackLight, function (_ref4) {
  var checked = _ref4.checked;
  return checked && "\n    color: ".concat(_userflow["default"].colors.blackBase, ";\n    ");
}, function (_ref5) {
  var isMobile = _ref5.isMobile;
  return !isMobile && "margin-left: 16px;";
});
var _default = exports["default"] = SubmitBlock;